import { Entity } from "../../../Entity";
import UserSettingsFactory from "../../../Factories/UserSettingsFactory";
import { FactoryInterface } from "../../../FactoryInterface";
import { LanguageInterface } from "../../../../Translation/LanguageInterface";
import { CurrencyInterface } from "../../../../Currency/CurrencyInterface";
import { UserSettingsInterface } from "./UserSettingsInterface";
import { LocaleInterface } from "../../Locale/LocaleInterface";

class UserSettings extends Entity implements UserSettingsInterface {

  constructor(public data) {
    super();
  }

  public getFactory(): FactoryInterface {
    return UserSettingsFactory;
  }

  get language(): LanguageInterface {
    return this.data.language;
  }

  get currency(): CurrencyInterface {
    return this.data.currency;
  }

  get locale(): LocaleInterface {
    return this.data.locale;
  }

  get beta(): boolean {
    return this.data.beta;
  }

  get launchPanelState(): boolean {
    return this.data.launchPanelState;
  }

  get entityPanelState(): boolean {
    return this.data.entityPanelState;
  }

  get finishWelcomeCoach(): boolean {
    return this.data.finishWelcomeCoach;
  }
}

export { UserSettings };
